cb.define(['common/common_VM.Extend.js'], function (common) {
  var AA_aa_vendor_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
			viewmodel.on("modeChange",function (data) {
				var CusId = cb.rest.AppContext.user.customer;
				var isOpenUdh = cb.rest.AppContext.tenant.isOpenUdh;
				if (CusId)
				{
					viewmodel.execute('updateViewMeta', { code:'aa_vendor_page_applyrange', visible: false });
					//viewmodel.execute('updateViewMeta', { code:'aa_vendortaborg', visible: false });
					//viewmodel.execute('updateViewMeta', { code:'aa_vendortab_cus', visible: false });
				}
				else
				{
					viewmodel.execute('updateViewMeta', { code:'aa_vendor_page_applyrange', visible: true });
					//viewmodel.execute('updateViewMeta', { code:'aa_vendortaborg', visible: true });	
					//if (isOpenUdh==true)
					//{viewmodel.execute('updateViewMeta', { code:'aa_vendortab_cus', visible: true });}
					//else
					//{viewmodel.execute('updateViewMeta', { code:'aa_vendortab_cus', visible: false });}
				}
	  		});
			var self = this;
			//var cusModel = viewmodel.get("vendorCustoms");
			var orgModel = viewmodel.get("vendorOrgs");
			/*
			if (cusModel) {
				cusModel.on('beforeCellValueChange', function (data) {
					switch (data.cellName) {
						case "custom_name":
						case "custom_code":
							{
								if (data.value.id != "")//检查是否存在重复的数据
								{
									var length = this.getRows().length;
									for (var i = 0; i < length; i++) {
										if (i != data.rowIndex) {
											if (data.value.id == this.getCellValue(i, 'custom')) {
												cb.utils.alert("已经分配该客户，请检查后重试！");
												return false;
											}
										}
									}
								}
								break;
							}
					}
				})
			}
			*/
			if (orgModel) {
				orgModel.on('beforeCellValueChange', function (data) {

					switch (data.cellName) {
						case "org_code":
						case "org_name":
							{
								if (data.value.id != "")//检查是否存在重复的数据
								{
									var length = this.getRows().length;
									for (var i = 0; i < length; i++) {
										if (i != data.rowIndex) {
											if (data.value.id == this.getCellValue(i, 'org')) {
												cb.utils.alert("已经分配该组织，请检查后重试！");
												return false;
											}
										}
									}
								}
								break;
							}

					}

				})
			}			
			//填写完名称后，自动填充助记码
			viewmodel.get("name").on('afterValueChange', function(data) {
				var name = viewmodel.get("name").getValue();
				if(name) {
					var mnemonicCode = common.getMnemonicCode(name); //得到数组
					var mnemonicCodeStr = "";
					for(var i = 0; i < mnemonicCode.length; i++) {
						var str = mnemonicCode[i] + ",";
						mnemonicCodeStr += str;

					}
					mnemonicCodeStr = mnemonicCodeStr.substring(0, mnemonicCodeStr.length - 1);
					viewmodel.get("vendorextends!helpcode").setValue(mnemonicCodeStr);
				} else {
					viewmodel.get("vendorextends!helpcode").setValue("");
				}
			}); 
			viewmodel.get("vendorextends!taxrate").on('beforeValueChange', function(data) {
				if(data)
				{
					if (data.value < 0 || data.value == '-' || data.value >= 100)
					{
						cb.utils.alert("[税率]只能录入0-100之间的值，请检查后重试！");
						return false;
					}					
				}					
			});
			viewmodel.on('afterLoadData', function(data) {
				if (viewmodel.getParams().mode=="add")
				{
					//组织附默认值
					var orgId = cb.rest.AppContext.user.orgId;
					var userOrgs = cb.rest.AppContext.user.userOrgs;
					var currentOrg = userOrgs && userOrgs.find(function (item) {
					  return item.org === orgId;
					});
					if (currentOrg) {
					  viewmodel.get("org").setValue(currentOrg.org);
					  viewmodel.get("org_name").setValue(currentOrg.org_name);
					}	
					//所属客户赋值
					var CusId = cb.rest.AppContext.user.customer;
					if(CusId)
					{viewmodel.get("custom").setValue(CusId);}
				}				
			});
			  viewmodel.on('beforeEdit', function (args) {
					return self.checkorg(viewmodel,args);
			  });	
			  viewmodel.on('beforeDelete', function (args) {
					return self.checkorg(viewmodel,args);
			  });			  
    },
	checkorg:function(viewmodel,args){
				var orgid = viewmodel.get("org").getValue();
				var userOrgs = cb.rest.AppContext.user.userOrgs;
				var findOrg=false;
				if (userOrgs)
				{
					userOrgs.forEach(function (item, index) {
						if (item.org==orgid)
						{
							findOrg=true;
						}
					});			
				}
				var custid = viewmodel.get("custom").getValue();
				var usercust = cb.rest.AppContext.user.customer;
				var findCust=false;
				if (usercust)
				{
					if (usercust==custid)
					{
						findCust=true;
					}
				}
				else
				{
					findCust=true;
				}
				if (findOrg==false || findCust==false) 
				{
					cb.utils.alert('没有权限对供应商进行此操作，请检查！', 'warning');
					return false;
				}
				else
				{return true;}
		}
  }
  try {
    module.exports = AA_aa_vendor_VM_Extend;
  } catch (error) {

  }
  return AA_aa_vendor_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_vendor_VM.Extend.js